import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withInMemoryScrolling} from '@angular/router';

import {routes} from './app.routes';
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';
import {apiInterceptor} from './core/inteceptors/api.interceptor';
import {loaderInterceptor} from './core/inteceptors/loader.interceptor';
import {IMAGE_LOADER, ImageLoaderConfig} from '@angular/common';
import {environment} from '../environments/environment';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideAnimations} from '@angular/platform-browser/animations';
import { authInterceptor } from './core/inteceptors/auth.interceptor';
import {httpStatusInterceptor} from './core/inteceptors/http-status.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withInMemoryScrolling({scrollPositionRestoration: 'top'})),
    provideAnimations(),
    provideHttpClient(
      withFetch(),
      withInterceptors([apiInterceptor, loaderInterceptor, authInterceptor, httpStatusInterceptor])
    ),
    {
      provide: IMAGE_LOADER,
      useValue: (config: ImageLoaderConfig) => {
        return `${environment.imageDomain}${config.src}`;
      },
    }, provideAnimationsAsync()
  ],
};
